import { useContext, useState } from "react";
import {
  CiroDropdownButton,
  CiroDropdownButtonItem,
} from "../../../shared/CiroDropdownButton";
import AutopilotCuratedSearchContext, {
  AutopilotCuratedSearchTypeEnum,
} from "../../../../contexts/AutopilotCuratedSearchContext";
import InternalSearchPowerUps from "./InternalSearchPowerUps";
import LsnSearchPowerUps from "./LsnSearchPowerUps";
import BulkCompanyEntryModal from "../../CuratedSearchFilters/BulkCompanyEntryModal";
import useCompanyNameHandling from "../../../../reactHooks/useCompanyNameHandling";
export type SearchPowerUpsModalState =
  | "startFromPriorSearch"
  | "bulkCompanyEntry"
  | null;

const SearchPowerUpsDropdown = ({
  specificCompanies,
  setSpecificCompanies,
}: {
  specificCompanies: string[];
  setSpecificCompanies: (companies: string[]) => void;
}) => {
  const { searchType } = useContext(AutopilotCuratedSearchContext);
  const [modalState, setModalState] = useState<SearchPowerUpsModalState>(null);

  const { companiesText, setCompaniesText, parseCompanies } =
    useCompanyNameHandling({
      initialCompanies: specificCompanies,
      onChange: setSpecificCompanies,
    });

  const handleSaveBulkCompanyEntry = () => {
    const newCompanies = parseCompanies(companiesText);
    setSpecificCompanies(newCompanies);
    setModalState(null);
  };

  return (
    <>
      <CiroDropdownButton label="Search modes">
        <CiroDropdownButtonItem
          analyticsField="Start from prior search"
          onClick={() => {
            setModalState("startFromPriorSearch");
          }}
        >
          Start from prior search
        </CiroDropdownButtonItem>
        <CiroDropdownButtonItem
          analyticsField="Search specific companies"
          onClick={() => {
            setModalState("bulkCompanyEntry");
          }}
        >
          Search specific companies
        </CiroDropdownButtonItem>
      </CiroDropdownButton>
      {searchType === AutopilotCuratedSearchTypeEnum.Internal && (
        <InternalSearchPowerUps
          modalState={modalState}
          setModalState={setModalState}
        />
      )}
      {searchType === AutopilotCuratedSearchTypeEnum.LinkedinSalesNavigator && (
        <LsnSearchPowerUps
          modalState={modalState}
          setModalState={setModalState}
        />
      )}
      <BulkCompanyEntryModal
        isOpen={modalState === "bulkCompanyEntry"}
        onClose={() => setModalState(null)}
        onSave={handleSaveBulkCompanyEntry}
        companiesText={companiesText}
        setCompaniesText={setCompaniesText}
      />
    </>
  );
};

export default SearchPowerUpsDropdown;
